export var ICON_STYLE_OPTIONS = [{
  id: 'regular',
  label: 'Outline',
  value: 'regular'
}, {
  id: 'solid',
  label: 'Solid',
  value: 'solid'
}];